var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gift"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5 5H2.5C2.22386 5 2 5.22386 2 5.5V7.5C2 7.77614 2.22386 8 2.5 8H13.5C13.7761 8 14 7.77614 14 7.5V5.5C14 5.22386 13.7761 5 13.5 5Z",
    stroke: "#777777",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13 8V12.5C13 12.6326 12.9473 12.7598 12.8536 12.8536C12.7598 12.9473 12.6326 13 12.5 13H3.5C3.36739 13 3.24021 12.9473 3.14645 12.8536C3.05268 12.7598 3 12.6326 3 12.5V8",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8 5V13",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.8284 4.29248C10.1213 4.99958 8 4.99959 8 4.99959C8 4.99959 8 2.87826 8.70711 2.17116C8.98847 1.89012 9.36991 1.73231 9.76759 1.73242C10.1653 1.73254 10.5466 1.89056 10.8278 2.17176C11.109 2.45296 11.2671 2.83432 11.2672 3.232C11.2673 3.62967 11.1095 4.01112 10.8284 4.29248V4.29248Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M5.17116 4.29248C5.87826 4.99958 7.99959 4.99959 7.99959 4.99959C7.99959 4.99959 7.99958 2.87826 7.29248 2.17116C7.01112 1.89012 6.62967 1.73231 6.232 1.73242C5.83432 1.73254 5.45296 1.89056 5.17176 2.17176C4.89056 2.45296 4.73254 2.83432 4.73242 3.232C4.73231 3.62967 4.89012 4.01112 5.17116 4.29248V4.29248Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/Gift.571d0eb4da694076ef73600ebc7e3290.svg";
export { ForwardRef as ReactComponent };